import cx from 'classnames';
import React from 'react';
import styles from './Label.module.scss';
export var Palette;
(function (Palette) {
    Palette["PRIMARY_BLUE"] = "primary-blue";
    Palette["DARK_BLUE"] = "dark-blue";
    Palette["DARK_BLUE_75"] = "dark-blue-75";
    Palette["DEEP_GREEN"] = "deep-green";
    Palette["VIVID_PINK"] = "vivid-pink";
    Palette["VIDID_ORANGE"] = "vivid-orange";
    Palette["STORM"] = "storm";
    Palette["RAIN"] = "rain";
    Palette["LIGHT_SILVER"] = "light-silver";
    Palette["CORAL"] = "coral";
    Palette["GREEN"] = "green";
    Palette["ORANGE"] = "orange";
    Palette["ORANGE_25"] = "orange-25";
    Palette["PURPLE"] = "purple";
    Palette["TEAL"] = "teal";
    Palette["RED"] = "red";
    Palette["BRONZE"] = "bronze";
    Palette["SILVER"] = "silver";
    Palette["GOLD"] = "gold";
})(Palette || (Palette = {}));
export var Variant;
(function (Variant) {
    Variant["SOLID"] = "solid";
    Variant["OUTLINE"] = "outline";
    Variant["OUTLINE_AND_TEXT"] = "outlineAndText";
    Variant["TEXT_ONLY"] = "text-only";
})(Variant || (Variant = {}));
export const A11yPalettes = [
    Palette.PRIMARY_BLUE,
    Palette.DARK_BLUE,
    Palette.DARK_BLUE_75,
    Palette.DEEP_GREEN,
    Palette.VIVID_PINK,
    Palette.STORM,
];
export const SolidOnlyPalettes = [
    Palette.RAIN,
    Palette.LIGHT_SILVER,
    Palette.CORAL,
    Palette.GREEN,
    Palette.ORANGE,
    Palette.ORANGE_25,
    Palette.PURPLE,
    Palette.TEAL,
    Palette.VIDID_ORANGE,
    Palette.RED,
];
const Label = ({ text, palette = Palette.PRIMARY_BLUE, variant = Variant.SOLID, uppercase = true, nowrap = false, }) => {
    return (<span className={cx(styles.label, {
            [styles.primaryBlue]: palette === Palette.PRIMARY_BLUE,
            [styles.darkBlue]: palette === Palette.DARK_BLUE,
            [styles.darkBlue75]: palette === Palette.DARK_BLUE_75,
            [styles.deepGreen]: palette === Palette.DEEP_GREEN,
            [styles.vividPink]: palette === Palette.VIVID_PINK,
            [styles.vividOrange]: palette === Palette.VIDID_ORANGE,
            [styles.storm]: palette === Palette.STORM,
            [styles.rain]: palette === Palette.RAIN,
            [styles.lightSilver]: palette === Palette.LIGHT_SILVER,
            [styles.coral]: palette === Palette.CORAL,
            [styles.green]: palette === Palette.GREEN,
            [styles.orange]: palette === Palette.ORANGE,
            [styles.orange25]: palette === Palette.ORANGE_25,
            [styles.purple]: palette === Palette.PURPLE,
            [styles.teal]: palette === Palette.TEAL,
            [styles.red]: palette === Palette.RED,
            [styles.bronze]: palette === Palette.BRONZE,
            [styles.silver]: palette === Palette.SILVER,
            [styles.gold]: palette === Palette.GOLD,
            [styles.solid]: variant === Variant.SOLID,
            [styles.outline]: variant === Variant.OUTLINE,
            [styles.outlineAndText]: variant === Variant.OUTLINE_AND_TEXT,
            [styles.textOnly]: variant === Variant.TEXT_ONLY,
            [styles.uppercase]: uppercase,
            [styles.nowrap]: nowrap,
        })}>
      {text}
    </span>);
};
export default Label;
